<template>
    <div>
        <section class="colorblock" v-if="['sidecolor', 'avgColor', 'dcolor1', 'dcolor2','accColor'].includes(props?.colorClarityBox)">
            <div class="images my-3" ref="scrollContainer">
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/color/m.svg">
                    <p :class="{ 'highlight': isHighlighted('M') }">M</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/color/l.svg">
                    <p :class="{ 'highlight': isHighlighted('L') }">L</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/color/k.svg">
                    <p :class="{ 'highlight': isHighlighted('K') }">K</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/color/j.svg">
                    <p :class="{ 'highlight': isHighlighted('J') }">J</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/color/i.svg">
                    <p :class="{ 'highlight': isHighlighted('I') }">I</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/color/h.svg">
                    <p :class="{ 'highlight': isHighlighted('H') }">H</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/color/g.svg">
                    <p :class="{ 'highlight': isHighlighted('G') }">G</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/color/f.svg">
                    <p :class="{ 'highlight': isHighlighted('F') }">F</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/color/e.svg">
                    <p :class="{ 'highlight': isHighlighted('E') }">E</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/color/d.svg">
                    <p :class="{ 'highlight': isHighlighted('D') }">D</p>
                </div>
            </div>
        </section>
        <section class="clarity" v-if="['sideclarity', 'avgClarity', 'dclarity1', 'dclarity2','diamClarity','accClarity'].includes(props?.colorClarityBox)">
            <div class="images my-3" ref="scrollContainer">
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/clarity/si2.svg">
                    <p :class="{ 'highlight': clairtyHighlighted('SI2') }">SI2</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/clarity/si1.svg">
                    <p :class="{ 'highlight': clairtyHighlighted('SI1') }">SI1</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/clarity/vs2.svg">
                    <p :class="{ 'highlight': clairtyHighlighted('VS2') }">VS2</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/clarity/vs1.svg">
                    <p :class="{ 'highlight': clairtyHighlighted('VS1') }">VS1</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/clarity/vvs2.svg">
                    <p :class="{ 'highlight': clairtyHighlighted('VVS2') }">VVS2</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/clarity/vvs1.svg">
                    <p :class="{ 'highlight': clairtyHighlighted('VVS1') }">VVS1</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/clarity/if.svg">
                    <p :class="{ 'highlight': clairtyHighlighted('IF') }">IF</p>
                </div>
                <div class="box">
                    <img width="115" height="72" src="/loose_graphics/clarity/fl.svg">
                    <p :class="{ 'highlight': clairtyHighlighted('FL') }">FL</p>
                </div>
        
            </div>
        </section>
        <section class="carat" v-if="['dcarat1', 'dcarat2'].includes(props?.colorClarityBox)">
            <div class="pictures" ref="scrollContainer">
                    <div class="box text-center">
                        <img width="304" height="304" src="/loose_graphics/carat/0.5ct.png" alt="Current Carat Image">
                        <div class="ct">0.5ct</div>
                        <div>(5.1mm)</div>
                    </div>
                    <div class="box text-center">
                        <img width="304" height="304" src="/loose_graphics/carat/0.75ct.png" alt="Current Carat Image">
                        <div class="ct">0.75ct</div>
                        <div>(5.8mm)</div>
                    </div>
                    <div class="box text-center">
                        <img width="304" height="304" src="/loose_graphics/carat/1ct.png" alt="Current Carat Image">
                        <div class="ct">1ct</div>
                        <div>(6.4mm)</div>
                    </div>
                    <div class="box text-center">
                        <img width="304" height="304" src="/loose_graphics/carat/1.5ct.png" alt="Current Carat Image">
                        <div class="ct">1.5ct</div>
                        <div>(7.4mm)</div>
                    </div>
                    <div class="box text-center">
                        <img width="304" height="304" src="/loose_graphics/carat/2ct.png" alt="Current Carat Image">
                        <div class="ct">2ct</div>
                        <div>(8.1mm)</div>
                    </div>
                    <div class="box text-center">
                        <img width="304" height="304" src="/loose_graphics/carat/2.5ct.png" alt="Current Carat Image">
                        <div class="ct">2.5ct</div>
                        <div>(8.9mm)</div>
                    </div>
                    <div class="box text-center">
                        <img width="304" height="304" src="/loose_graphics/carat/3ct.png" alt="Current Carat Image">
                        <div class="ct">3ct</div>
                        <div>(9.3mm)</div>
                    </div>
                    <div class="box text-center">
                        <img width="304" height="304" src="/loose_graphics/carat/3.5ct.png" alt="Current Carat Image">
                        <div class="ct">3.5ct</div>
                        <div>(9.75mm)</div>
                    </div>
                    <div class="box text-center">
                        <img width="304" height="304" src="/loose_graphics/carat/4ct.png" alt="Current Carat Image">
                        <div class="ct">4ct</div>
                        <div>(10.1mm)</div>
                    </div>
                </div>
        </section>
        <section class="cut" v-if="['dcut1', 'dcut2'].includes(props?.colorClarityBox)">

            <div class="images my-3" ref="scrollContainer">
                        <div class="box text-center">
                            <img width="115" height src="/loose_graphics/newcut/fair.svg">
                            <p :class="{ 'highlight': cutHighlighted('Fair') }">Fair</p>
                        </div>
                        <div class="box text-center">
                            <img width="115" height src="/loose_graphics/newcut/good.svg">
                            <p :class="{ 'highlight': cutHighlighted('Good') }">Good</p>
                        </div>
                        <div class="box text-center">
                            <img width="115" height src="/loose_graphics/newcut/verygood.svg">
                            <p :class="{ 'highlight': cutHighlighted('Very Good') }">Very Good</p>
                        </div>
                        <div class="box text-center">
                            <img width="115" height src="/loose_graphics/newcut/excellent.svg">
                            <p :class="{ 'highlight': cutHighlighted('Excellent') }">Excellent</p>
                        </div>
                        <div class="box text-center">
                            <img width="115" height src="/loose_graphics/newcut/ideal.svg">
                            <p :class="{ 'highlight': cutHighlighted('Ideal') }">Ideal</p>
                        </div>

                    </div>

        </section>
    </div>
</template>


<script setup>
const props = defineProps(['item','colorClarityBox','dData','detailData','complete','currentClarity','presetsubtype','moduleSubType']);
// console.log(props,'INSIDE MODALIMAGESCROLL');
const colorRange = ref(props?.item);
const route = useRoute();
// console.log(route.meta.name// cyo-diamond-detail-ring  cyo-diamond-detail-earring
// ,'ABC');


// intiazilat
const scrollContainer = ref('')
const startX = ref(0);
const isDown = ref(false)
const scrollLeft = ref(0);

const isHighlighted = (letter) => {
   
   if (props?.dData?.sub_type === 'in-stock-ring' ) {
       const stoneColor = props?.dData?.stone_one_color;
       if (stoneColor) {
           return stoneColor.toUpperCase() === letter?.toUpperCase();
       }
       return false; 
   }
   if (props?.dData?.sub_type === 'in-stock-pendant' ) {
       const stoneColor = props?.dData?.stone_one_color;
       if (stoneColor && stoneColor?.length >= 2) {
           let range = stoneColor;

           if (typeof range === 'string') {
               range = range?.split('');
           } else if (!Array.isArray(range)) {
               return false; 
           }

           const upperRange = range?.map(c => c?.toUpperCase());
           return upperRange.includes(letter?.toUpperCase());
       } else if (stoneColor) {
           return stoneColor?.toUpperCase() === letter?.toUpperCase();
       }
       return false; 
   }
   if (props?.dData?.sub_type === 'in-stock-earring') {
       const stoneColor = filteredDiamonds?.value[0]?.color || filteredDiamonds?.value[1]?.color || '';

       if (stoneColor && stoneColor?.length >= 2) {
           let range = stoneColor;
        //    console.log(filteredDiamonds?.value[1]?.color, '========', filteredDiamonds?.value[0]?.color);

           if (typeof range === 'string') {
               range = range?.split('');
           } else if (!Array.isArray(range)) {
               return false; 
           }

           const upperRange = range.map(c => c?.toUpperCase());
           return upperRange?.includes(letter?.toUpperCase());
       } else if (stoneColor) {
           return stoneColor.toUpperCase() === letter?.toUpperCase();
       }
       return false; 
   }
   

   let range = colorRange.value;

  
   if (typeof range === 'string') {
       range = range.split('');
   } else if (Array.isArray(range)) {
  
   } else {
       return false; 
   }

   const upperRange = range.map(c => c?.toUpperCase());
   return upperRange.includes(letter?.toUpperCase());
};


const scrollToHighlightedImage = () => {
    const scroll_Container = scrollContainer?.value;
    if (scrollContainer?.value) {
        const highlightedElement = scroll_Container?.querySelector('.highlight');
        if (highlightedElement) {
            highlightedElement.scrollIntoView({ behavior: 'smooth', inline: 'start' });
        }
    }
};

function initHorizontalScroll() {
    if(scrollContainer?.value){
        const scroll_Container = scrollContainer?.value;

        scroll_Container?.addEventListener('mousedown', (e) => {
            isDown.value = true;
            startX.value = e.pageX - scroll_Container.offsetLeft;
            scrollLeft.value = scroll_Container.scrollLeft;

        });

        scroll_Container.addEventListener('mouseleave', () => {
            isDown.value = false;
        });

        scroll_Container.addEventListener('mouseup', () => {
            isDown.value = false;
        });

        scroll_Container.addEventListener('mousemove', (e) => {
            if (!isDown.value) return;
            e.preventDefault();
            const x = e.pageX - scroll_Container.offsetLeft;
            const walk = (x - startX.value) * 3; // Adjust scrolling speed here
            scroll_Container.scrollLeft = scrollLeft.value - walk;
        });
    }
}
const resetState = () => {
    if (scrollContainer.value) {
        scrollContainer.value.scrollLeft = 0;
    }
    colorRange.value = props?.item;
};
const cutHighlighted = (letter)=>{
        let range = colorRange.value;
        return range.toUpperCase() === letter.toUpperCase();
}
const filteredDiamonds = computed(() => {
    return props?.dData?.diamonds?.filter(diamond => diamond?.weight && diamond?.shape)
    .map(diamond => ({
        weight: diamond?.weight || '',
        shape: diamond?.shape || '',
        clarity: diamond?.clarity || '',
        color: diamond?.color || '',
    }));
});
// console.log(filteredDiamonds.value,'=========');

const clairtyHighlighted = (letter) => {
  const subTypes = [
    'ring', 'earring', 'pendant', 'band-ring', 'full-eternity-ring',
    'anniversary-ring', 'toi-et-moi-ring', 'couple-bands-ring', 
    'tennis-bracelet','openable-bangle', 'fashion-bracelet', 'fashion-earring','fashion-necklace', 
    'hoop-earring', 'solitaire-necklace', 'tennis-necklace', 
    'stud-earring', 'in-stock-ring', 'in-stock-earring',  'in-stock-pendant','soiree-ring','hues-ring','soiree-earring',,'roses-portraits-ring'
  ];

  // Check if subType matches
  const isSubTypeMatch =
    subTypes.includes(props?.moduleSubType) ||
    subTypes.includes(props?.detailData?.sub_type) ||
    props?.complete === 'ring' ||
    props?.complete === 'pendant' ||
    props?.complete === 'earring' ||
    props?.moduleSubType === 'ring' ||
    props?.moduleSubType === 'earring' ||
    props?.moduleSubType === 'pendant' ||
    props?.presetsubtype === 'preset';

  if (isSubTypeMatch) {
    // Only highlight VS1 or VS2 for matching subtypes
    return letter === 'VS1' || letter === 'VS2';
  }
  // Checking for specific 'in-stock-pendant' subtype logic
  if (props?.dData?.sub_type === 'in-stock-pendant') {
    const clarity = props?.dData?.stone_one_clarity?.toUpperCase();
    if (clarity === 'VS' || clarity === 'VVS') {
      return letter === 'VS1' || letter === 'VS2';
    }
    if(clarity === 'VVS-VS'){
        return letter === 'VS1' || letter === 'VS2' || letter === 'VVS1' || letter === 'VVS2'; 
    }
  }
  if (props?.dData?.sub_type === 'in-stock-earring') {
    const clarity = filteredDiamonds.value[0].clarity.toUpperCase();
    // console.log(clarity,'===========');
    
    if (clarity === 'VS' || clarity === 'VVS') {
      return letter === 'VS1' || letter === 'VS2';
    }
    if (clarity === 'VVS-VS') {
      return letter === 'VS1' || letter === 'VS2' || letter === 'VVS1' || letter === 'VVS2';
    }
  }
  // Check route meta name logic
  if (
    route?.meta?.name === 'cyo-diamond-detail-ring' ||
    route?.meta?.name === 'cyo-diamond-detail-earring' || 
    route?.meta?.name === 'preset-detail' || 
    route?.meta?.name === "cyo-diamond-detail-earring"
  ) {
    // If the colorRange is 'vs', only highlight 'VS1' or 'VS2'
    if (colorRange.value === 'vs' && (letter === 'VS1' || letter === 'VS2')) {
      return true;
    } else {
      // Otherwise, return the clarity from props.item for non-matching clarity values
      return props?.item?.toUpperCase() === letter?.toUpperCase();
    }
  }

  // Handle preset subtype or in-stock-ring subtype
  if (props?.presetsubtype === 'preset' || props?.dData?.sub_type === 'in-stock-ring' ) {
    return (
      props.dData?.clarity?.toUpperCase() === letter?.toUpperCase() ||
      props.dData?.clarity_one?.toUpperCase() === letter?.toUpperCase() ||
      props.dData?.stone_one_clarity?.toUpperCase() === letter?.toUpperCase()
    );
  }

  // Default case: If route.meta.name doesn't match and is not any special subtype, return the item value
  return props?.item?.toUpperCase() === letter?.toUpperCase();
};
onMounted(() => {
    initHorizontalScroll();   
    scrollToHighlightedImage();
    resetState()
})

defineExpose({
    scrollToHighlightedImage,
    resetState,
    initHorizontalScroll
});
</script>



<style scoped>
.highlight {
    color: #668b84;
    font-weight: bold;
    text-decoration: underline;
  }

.largesvg {
    transform: scale(1.3);
    }

.images {
    display: flex;
    overflow-x: auto; 
    gap: 16px;
    align-items: center;
    cursor: pointer;
}

.images .box {
    flex: 0 0 auto; 
    width: auto; 
    text-align: center;
    user-select: none;
}

.pop_open {
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block {
    display: flex;
    align-items: center;
    justify-content: space-between;
}


p {
    font-size: 16px;
    color: #606060;
}

.title_block span {
    cursor: pointer;
    color: var(--green);
}

h3 {
    font-size: 22px;
}
.box{
 width: 25%;
}
.m-info {
    margin: 10px 0;
}
.pictures {
    display: flex;
    overflow-x: auto; 
    gap: 16px;
    align-items: center;
    cursor: pointer;
    padding-bottom: 10px;
    margin-top: 10px;
}

.pictures .box {
    flex: 0 0 auto; 
    width: 80px;
    user-select: none;
}

.box .ct {
    font-weight: 600;
}
/* -----scroll--------- */
/* width */
.pictures::-webkit-scrollbar {
    width: 5px;
    height: 3px;
  }
  
  /* Track */
  .pictures ::-webkit-scrollbar-track {
    background: #f5f5f5; 
  }
   
  /* Handle */
  .pictures::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
    cursor: pointer;
  }
  
  /* Handle on hover */

  /* -----scroll--------- */



/* -----scroll--------- */
/* width */
.images::-webkit-scrollbar {
    width: 5px;
    height: 3px;
  }
  
  /* Track */
  .images ::-webkit-scrollbar-track {
    background: #f5f5f5; 
  }
   
  /* Handle */
  .images::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
    cursor: pointer;
  }
  
  /* Handle on hover */

  /* -----scroll--------- */
@media(max-width: 767px) {
    h3 {
        font-size: 20px;
    }
    p {
        font-size: 14px;
    }

}
</style>